module.exports = __webpack_public_path__ + "static/img/index_btn_4.936590c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_btn_4.png
// module id = wBQ9
// module chunks = 1